// extracted by mini-css-extract-plugin
export default {"root":"LogoutButton_root__P8QgJ","icon":"LogoutButton_icon__Y-ArO","text":"LogoutButton_text__vm7fG"};